import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerUserContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { ServerUsers } from '~src/userManagement/services/resources/ServerUsers';
import { ServerUsersWithTokenResource } from '~src/userManagement/services/resources/ServerUsersWithToken';

import { getNoDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const ServerUserDefinition: SpaceDefinition<'serveruser'> & ExplorableItemDefinition = {
  itemType: 'serveruser',
  contentType: 'serveruser',
  singularName: Messages.serverUser,
  pluralName: Messages.serverUsers,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: ServerUserContentType.filterKeys,
  filterClause: ServerFilterClauses.ContentType(['serveruser']) as ContentTypeFilterClause,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconType: null,
  contentSpaceUrl: (urls, id) => '', // note this is used for breadcrumbs/clicking on card and list view, //might have to be refactored to take in the entire item
  headerIconPath: (contentInfo: ISpaceItemDetailInfo<'serveruser'>) => {
    if (contentInfo.userImageUrl) {
      return contentInfo.userImageUrl;
    }
    return imgPath('user_content_type.svg');
  },
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    return ServerUsers.instance.all();
  },
  getResourceTokenQuery: () => {
    return ServerUsersWithTokenResource;
  }
};
